import { Colors } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { SeenHoverLink } from './SeenHoverLink';

export interface SeenByCountTextProps {
  count: number;
  color?: string;
}

export function SeenByCountText({ count, color = Colors.v2.gray30 }: SeenByCountTextProps) {
  return <SeenHoverLink content={i18n('chat.seenBy', { count })} color={color} />;
}
